import { Product } from '@/core/interfaces';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface shopState {
	products: Product[];
	visibleModalInsufficientGems: boolean;
}

const shopSlice = createSlice({
	name: 'shop',
	initialState: {
		products: [],
		visibleModalInsufficientGems: false,
	} as shopState,
	reducers: {
		setProducts: (state, action: PayloadAction<Product[]>) => {
			state.products = action.payload;
		},
		setVisibleModalInsufficientGems: (
			state,
			action: PayloadAction<boolean>
		) => {
			state.visibleModalInsufficientGems = action.payload;
		},
	},
});

const { reducer, actions } = shopSlice;

export const { setProducts, setVisibleModalInsufficientGems } = actions;
export default reducer;
